import { get, isEmpty, isNil } from "lodash";
import { MdArrowBackIos, MdArrowForwardIos } from "react-icons/md";
import ActionButtons from "../Components/ActionButtons";
import { gridColumns, hasAddableOptionColumn } from "../coverageGrid";
import Configurator from "./Configurator";
import GuaranteeGrid from "./GuaranteeGrid";
import ProductHeader from "./ProductHeader";
import Simulator from "./Simulator";

const View = ({
  translation: T,
  levelPlans,
  upsellPlans,
  offeredUpsellIds,
  catalogLoading,
  combinations,
  coveragePlans,
  coveragePlansById,
  structure,
  regime,
  headcounts,
  commercialAdjustment,
  compositionErrors,
  allocationErrors,
  cost,
  costPending,
  costLoading,
  costRefreshing,
  costFailed,
  onPlanChange,
  onUpsellToggle,
  onOptionAdd,
  onOptionRemove,
  onStructureChange,
  onRegimeChange,
  onHeadcountChange,
  onCommercialAdjustmentChange,
  onBack,
  onSubmit,
  nextLoading,
  disabled,
  documents,
}) => (
  <div className="ac-collectif contact-form">
    <ProductHeader
      translation={T}
      vintage={get(cost, "costDetails.vintage")}
      documents={documents}
    />
    <div className="ac-collectif__split contact-form__content mb-16">
      <div className="ac-collectif__split-left">
        <Configurator
          translation={T}
          levelPlans={levelPlans}
          upsellPlans={upsellPlans}
          offeredUpsellIds={offeredUpsellIds}
          catalogLoading={catalogLoading}
          combinations={combinations}
          compositionErrors={compositionErrors}
          onPlanChange={onPlanChange}
          onUpsellToggle={onUpsellToggle}
          onOptionAdd={onOptionAdd}
          onOptionRemove={onOptionRemove}
          disabled={disabled}
        />
        <GuaranteeGrid
          translation={T}
          plans={coveragePlans}
          columns={gridColumns(combinations, coveragePlansById)}
          showGhostColumn={hasAddableOptionColumn(combinations)}
        />
      </div>
      <div className="ac-collectif__split-right">
        <Simulator
          translation={T}
          structure={structure}
          regime={regime}
          headcounts={headcounts}
          allocationErrors={allocationErrors}
          commercialAdjustment={commercialAdjustment}
          cost={cost}
          costLoading={costLoading}
          costRefreshing={costRefreshing}
          costFailed={costFailed}
          onStructureChange={onStructureChange}
          onRegimeChange={onRegimeChange}
          onHeadcountChange={onHeadcountChange}
          onCommercialAdjustmentChange={onCommercialAdjustmentChange}
          disabled={disabled}
        />
      </div>
    </div>
    <ActionButtons
      onBack={onBack}
      onSubmit={onSubmit}
      loading={nextLoading}
      disabled={{
        next:
          nextLoading ||
          disabled ||
          costPending ||
          !isEmpty(compositionErrors) ||
          !isEmpty(allocationErrors) ||
          isNil(cost),
      }}
      icons={{
        next: <MdArrowForwardIos size={16} />,
        previous: <MdArrowBackIos size={16} />,
      }}
      translation={T.ACTIONS}
    />
  </div>
);

export default View;
